import React, {useEffect, useState} from 'react';
import {ITableGroups, TableList} from "../../../../../components/table";
import {OperacionCLGDetalleFields, OperacionCLGFields} from "../types/fields";
import CardActions from "../../../components/CardActions";
import {OperacionCLG} from "../types/types";
import {HttpCLG} from "../api/HttpCLG";
import {z} from "../../../../../lib";
import {EntityWithIdFields} from "../../../../../types";
import AforoField, {FormActualizarAforo} from "./AforoField";
import {useForm} from "react-hook-form";
import {useDetalleCLG} from '../hooks/useDetalleCLG';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    useMediaQuery,
    useTheme
} from '@mui/material';
import {ICON_MAS} from 'src/pages/sistema/components/SharedIcons';
import {Button, ControlledTextField} from 'src/components/forms';
import {FormInsertarEspecie, schemaFormInsertarEspecie} from '../types/especie';
import {zodResolver} from '@hookform/resolvers/zod';
import CLGDetalleTabla from "./CLGDetalleTabla";
import {useLimiteCLG} from "../hooks/useLimiteCLG";

type SeccionCLGDatosGarantiasProps = {
    operacion: OperacionCLG
}

const aforoSchema = z.object({
    id: z.number(),
    [OperacionCLGDetalleFields.Aforo]: z.string(),
    [OperacionCLGDetalleFields.OrdenSeccion]: z.number(),
    [OperacionCLGDetalleFields.Sector]: z.string(),
    [OperacionCLGDetalleFields.PermiteModificar]: z.boolean(),
    [OperacionCLGDetalleFields.CodEspecie]: z.number(),
    [OperacionCLGDetalleFields.CodSeccion]: z.number(),
    [OperacionCLGDetalleFields.Especie]: z.string(),
});

export type AforoCelda = z.infer<typeof aforoSchema>

const schemaCLGDetalleFila = z
    .object({
        [EntityWithIdFields.Id]: z.number(),
        [OperacionCLGDetalleFields.IdOperacion]: z.number(),
        [OperacionCLGDetalleFields.IdCabecera]: z.number().nullable(),
        [OperacionCLGDetalleFields.Especie]: z.string(),
        [OperacionCLGDetalleFields.OrdenEspecie]: z.number(),
        [OperacionCLGDetalleFields.OrdenCabecera]: z.number(),
        listaAforo: z.array(aforoSchema),
    })

export type CLGDetalleFila = z.infer<typeof schemaCLGDetalleFila>

function SeccionCLGDatosDetalle({operacion}: SeccionCLGDatosGarantiasProps) {
    const {data, refetch} = useDetalleCLG(operacion[OperacionCLGFields.CodPais], operacion.id)

    const formNuevaEspecie = useForm<FormInsertarEspecie>({
        resolver: zodResolver(schemaFormInsertarEspecie)
    })

    const [openDialog, setOpenDialog] = useState<boolean>(false);

    const closeDialog = () => {
        refetch()
        setOpenDialog(false)
    }

    const onNuevaEspecie = () => {
        if (operacion[OperacionCLGFields.PermiteEditar]){
            return new Promise<void>((resolve, reject) => {
                formNuevaEspecie.handleSubmit(
                  (formData) => {
                      HttpCLG.postEspecie(operacion.id, formData)
                        .then(() => {
                            setTimeout(closeDialog, 500);
                            resolve()
                        })
                        .catch(reject)
                  },
                  (validationErrors) => {
                      console.log(validationErrors)
                      reject(validationErrors)
                  }
                )()
            })
        }
        else {
            return new Promise<void>((resolve, reject) => {
                resolve();
            });
        }
    }


    return (
        <CardActions
            title={"Detalle"}
            icon='mdi:table'
            colapsable
            tableContent
            actions={
                    operacion[OperacionCLGFields.PermiteEditar]
                      &&
                      <Button variant="contained" color="primary" endIcon={ICON_MAS} onClick={() => setOpenDialog(true)}>
                          Nuevo
                      </Button>
                  }
            >

            <CLGDetalleTabla
                data={data}
                idOperacion={operacion.id}
                />

            {/*{*/}
            {/*    data.map((group, index) => {*/}
            {/*        const columns: any[] = [];*/}
            {/*        columns.push({label: `Especie`, value: OperacionCLGDetalleFields.Especie});*/}
            {/*        for (let i = 0; i < group[0].listaAforo.length; i++) {*/}
            {/*            columns.push({*/}
            {/*                label: `Porcentaje de Aforo`, onRenderCell: (item: CLGDetalleFila) =>*/}

            {/*                    item.listaAforo[i] ?*/}
            {/*                    <AforoField*/}
            {/*                      onUpdateAforo={onUpdateAforo}*/}
            {/*                      fila={item}*/}
            {/*                      aforo={item.listaAforo[i]}*/}
            {/*                      permiteEditar={item.listaAforo[i]?.[OperacionCLGDetalleFields.PermiteModificar]}*/}
            {/*                      iniciaEditando={!operacion?.id}*/}
            {/*                    />*/}
            {/*                      : <span></span>*/}


            {/*            });*/}
            {/*        }*/}

            {/*        const gruposColumnas: ITableGroups[] = group[0].listaAforo.map((item, index) => {*/}
            {/*            return {*/}
            {/*                firstColumn: index + 1 ,*/}
            {/*                lastColumn: index + 1,*/}
            {/*                label: item[OperacionCLGDetalleFields.Sector]*/}
            {/*            }*/}
            {/*        })*/}

            {/*        if (isSmallScreen) {*/}
            {/*            return (*/}
            {/*              gruposColumnas.map((grupo, idx) => {*/}
            {/*                  const columnaGrupo = {*/}
            {/*                      firstColumn: 0,*/}
            {/*                      lastColumn: 1,*/}
            {/*                      label: grupo.label*/}
            {/*                  }*/}

            {/*                  return (*/}

            {/*                    <TableList*/}
            {/*                      key={index}*/}
            {/*                      entityList={group}*/}
            {/*                      columns ={[columns[0], ...columns.slice(idx + 1, idx + 2)]}*/}
            {/*                      columnGroups={[columnaGrupo]}*/}
            {/*                      isLoading={false}*/}
            {/*                      error={false}*/}
            {/*                    />*/}

            {/*                  )*/}
            {/*              })*/}
            {/*            )*/}
            {/*        }*/}

            {/*        return (*/}
            {/*            <TableList*/}
            {/*                key={index}*/}
            {/*                entityList={group}*/}
            {/*                columns={columns}*/}
            {/*                columnGroups={gruposColumnas}*/}
            {/*                isLoading={false}*/}
            {/*                error={false}*/}
            {/*            />*/}
            {/*        );*/}
            {/*    })*/}
            {/*}*/}
            <Dialog open={openDialog} fullWidth maxWidth='sm' keepMounted={false}>
                <DialogTitle>Nueva especie</DialogTitle>
                <DialogContent>
                    <DialogContentText>Indique el nombre de la nueva especie.</DialogContentText>
                    <Grid container spacing={4} sx={{pt: 2}}>
                        <Grid item xs={12} md={6}>
                            <ControlledTextField
                                control={formNuevaEspecie.control}
                                name='especie'
                                label='Especie'
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant='text'
                        color='primary'
                        onClick={() => setOpenDialog(false)}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant='contained'
                        color='primary'
                        promise={onNuevaEspecie}
                    >
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        </CardActions>
    );
}

export default SeccionCLGDatosDetalle;
